import { render, staticRenderFns } from "./ArtigosStatsHero.vue?vue&type=template&id=20951684&scoped=true&"
import script from "./ArtigosStatsHero.vue?vue&type=script&lang=js&"
export * from "./ArtigosStatsHero.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosStatsHero.vue?vue&type=style&index=0&id=20951684&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20951684",
  null
  
)

export default component.exports